<template>
    <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M5.27992 0.704407H2.99201V5.28022H5.27992V0.704407ZM9.85574 0.704407H7.56783V5.28022H9.85574V0.704407ZM12.1436 0.704407H14.4316V5.28022H12.1436V0.704407ZM21.2953 7.56813H0.704102V21.2956H16.7195V15.5758H21.2953V7.56813ZM19.0074 13.2879H16.7195V9.85604H19.0074V13.2879ZM2.99201 9.85604H14.4316V19.0077H2.99201V9.85604Z"/>
    </svg>
</template>
